/**
 * @generated SignedSource<<1a1421f096630fb62da5ae31f394f3fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TextInputElement_input$data = {
  readonly __id: string;
  readonly descriptionHTML: string | null;
  readonly itemId: string | null;
  readonly label: string;
  readonly placeholder: string | null;
  readonly required: boolean | null;
  readonly value: string | null;
  readonly " $fragmentType": "TextInputElement_input";
};
export type TextInputElement_input$key = {
  readonly " $data"?: TextInputElement_input$data;
  readonly " $fragmentSpreads": FragmentRefs<"TextInputElement_input">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TextInputElement_input",
  "selections": [
    {
      "alias": "itemId",
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "descriptionHTML",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "placeholder",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "required",
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "IssueFormElementInput",
  "abstractKey": null
};

(node as any).hash = "20ef068a2834313afaaf43e8b01d0d49";

export default node;
